/**
 * Получает отображаемое имя пациента с единой логикой fallback
 * @param {Object} patient - Объект пациента
 * @param {string} [patient.full_name] - Полное имя пациента
 * @param {string} [patient.username] - Имя пользователя
 * @param {string} [patient.email] - Email пациента
 * @param {number} [patient.id] - ID пациента (используется только для внутренних целей)
 * @returns {string} Отображаемое имя пациента
 */
export function getPatientDisplayName(patient) {
    if (!patient) {
        return "Имя не указано";
    }
    
    // Приоритет: full_name -> username -> "Имя не указано"
    return patient.full_name || patient.username || "Имя не указано";
}

/**
 * Получает инициалы пациента для аватара
 * @param {Object} patient - Объект пациента
 * @param {string} [patient.full_name] - Полное имя пациента
 * @param {string} [patient.username] - Имя пользователя
 * @param {string} [patient.email] - Email пациента
 * @returns {string} Инициалы (максимум 2 символа) или дефолтное значение
 */
export function getPatientInitials(patient) {
    if (!patient) {
        return "П";
    }
    
    const displayName = getPatientDisplayName(patient);
    
    // Если имя не указано, возвращаем дефолтную букву
    if (displayName === "Имя не указано") {
        return "П";
    }
    
    // Извлекаем первые буквы из каждого слова
    const initials = displayName
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    
    return initials || "П";
}

/**
 * Проверяет, указано ли имя пациента
 * @param {Object} patient - Объект пациента
 * @returns {boolean} true, если имя указано, false - если нет
 */
export function hasPatientName(patient) {
    if (!patient) {
        return false;
    }
    
    return !!(patient.full_name || patient.username);
}
